enum UserParent {
  COMPANY = "company",
  SITE = "site",
}

export default UserParent;
